import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import makeGetUserFieldsFetch from 'fetches/makeGetUserFieldsFetch';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Attributes from 'pages/Attributes';
import ProfileLayoutPage from 'pages/ProfileLayout';
import SiftBotPage from 'pages/SiftBot';
import Page from 'components/Page/newComponents';
import Breadcrumbs from 'components/Page/Breadcrumbs';
import PageTitle from 'components/Page/PageTitle';

import { PERSON_PROFILE_URL } from 'components/Router/consts';

const tabTypes = {
  ATTRIBUTES: 'attributes',
  LAYOUT: 'layout',
  PROFILE_COMPLETION: 'sift-bot',
};

function PersonProfilesPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  let { tab } = useParams<{ tab?: string }>();
  const currentTab = tab || tabTypes.ATTRIBUTES;
  const makeGetUserFields = makeGetUserFieldsFetch();

  useEffect(() => {
    dispatch(makeGetUserFields());
    document.title = 'Person Profiles';
  }, []);

  const handleTabChange = (value: string) => {
    history.push(`/admin${PERSON_PROFILE_URL}/${value}`);
  };

  return (
    <Page>
      <Breadcrumbs routes={['Home']} />
      <PageTitle title="Person Profiles" />
      <Tabs value={currentTab} onChange={(e, value) => handleTabChange(value)}>
        <Tab label="Attributes" value={tabTypes.ATTRIBUTES} />
        <Tab label="Layout" value={tabTypes.LAYOUT} />
        <Tab label="Profile Completion" value={tabTypes.PROFILE_COMPLETION} />
      </Tabs>
      <div>
        <div>{currentTab === tabTypes.ATTRIBUTES && <Attributes typeKey="user" />}</div>
        <div>{currentTab === tabTypes.LAYOUT && <ProfileLayoutPage typeKey="user" />}</div>
        <div>{currentTab === tabTypes.PROFILE_COMPLETION && <SiftBotPage />}</div>
      </div>
    </Page>
  );
}

export default PersonProfilesPage;
